import React from "react";
import { makeStyles } from "@material-ui/core";
import { Box, Typography, Tab, Tabs } from "@material-ui/core";
import UserChip from "UserChip";
import reportsBackground from "bg-reports.jpg";

const useStyles = makeStyles(theme => ({
  header: {
    position: "relative",
    height: 212,
    background: `url(${reportsBackground}) no-repeat center/100%`,
    maxWidth: "100%",
  },
  title: {
    position: "relative",
    top: 95,
    left: 55,
    "@media (min-width: 600px)": {
      top: 78,
    },
  },
  userChip: {
    position: "absolute",
    right: 30,
    top: 30,
  },
  tabs: {
    position: "absolute",
    bottom: 0,
    left: 55,
  },
}));

const ReportsHeader = ({ currentTab, handleTabChange }) => {
  const classes = useStyles();

  return (
    <Box className={classes.header}>
      <UserChip className={classes.userChip} />
      <Typography className={classes.title} variant="h1">
        BiblioBoard Reporting
      </Typography>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        className={classes.tabs}
      >
        <Tab id={0} label="COUNTER" />
        <Tab id={1} label="INVENTORY" />
        <Tab id={2} label="USAGE" />
        <Tab id={3} label="SESSION" />
        <Tab id={4} label="MARC" />
        <Tab id={5} label="KBART" />
        <Tab id={6} label="INDIE AUTHOR PROJECT" />
      </Tabs>
    </Box>
  );
};

export default ReportsHeader;
